"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viasTransporte = void 0;
exports.viasTransporte = {
    maritimo: { nombre: "Marítimo", sigla: "1" },
    aereo: { nombre: "Aéreo", sigla: "2" },
    terrestre: { nombre: "Terrestre", sigla: "3" },
    null: { nombre: "N/A", sigla: "8" },
    otro: { nombre: "Otro", sigla: "9" }
};
